module.exports = __webpack_public_path__ + "img/Bold 2px-person-white.a5216246.svg";